import type { ResponseLike } from '../types.js';
import { normalizeHeader } from '../utils/normalize.js';

export interface ParsedX402Error {
  code?: string | undefined;
  message?: string | undefined;
  severity?: string | undefined;
  raw?: any;
}

export async function parseX402Response(res: ResponseLike): Promise<ParsedX402Error | null> {
  if (!res || !res.headers) {
    return null;
  }

  const headers = res.headers;
  
  // Check for x402-specific headers (case-insensitive)
  let code: string | undefined;
  let message: string | undefined;
  let severity: string | undefined;
  
  // Try to get headers with various casing
  const possibleHeaders = [
    'x-x402-code',
    'x-x402-message', 
    'x-x402-severity',
    'X-X402-CODE',
    'X-X402-MESSAGE',
    'X-X402-SEVERITY'
  ];
  
  for (const headerName of possibleHeaders) {
    const value = headers.get(headerName);
    if (value) {
      const normalized = normalizeHeader(headerName);
      if (normalized === 'x-x402-code') {
        code = value.trim();
      } else if (normalized === 'x-x402-message') {
        message = value.trim();
      } else if (normalized === 'x-x402-severity') {
        severity = value.trim();
      }
      // Found at least one x402 header, continue to collect others
    }
  }
  
  // If no x402 headers found, this is not an x402 error
  if (!code && !message && !severity) {
    return null;
  }
  
  // Try to parse JSON body for additional context
  let rawData: any;
  try {
    rawData = await res.json();
  } catch {
    // JSON parsing failed, ignore
  }
  
  return {
    code,
    message,
    severity,
    raw: rawData
  };
}